export default __webpack_public_path__ + "static/media/canada-banner.fc46a532.png";